var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.702,
    transform: "translate(22136.66 7127.118)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4704",
    transform: "translate(-22125.105 -7116.324)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 625",
    transform: "translate(7.751 7.916)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 626",
    transform: "translate(0 14.956)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 627",
    transform: "translate(13.952 17.405)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 628",
    transform: "translate(18.83 9.782)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 629",
    transform: "translate(29.386 6.045)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 630",
    transform: "translate(19.446)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 631",
    transform: "translate(27.751 15.923)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 632",
    transform: "translate(39.13 13.957)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-22104.537-7126.202c4.123.655 5.921 5.425 9.486 7.506 1.765 1.031 3.906 1.356 5.663 2.4 2.179 1.29 3.538 3.535 5.54 5.064 2.541 1.941 6.076 2.7 8.033 5.187 1.476 1.873 1.742 4.363 1.718 6.707a4.385 4.385 0 0 1-2.809 4.234 91.4 91.4 0 0 1-28.144 5.539c-11.607.374-22.73-3.5-27.706-5.525a4.7 4.7 0 0 1-3.048-4.452 12.448 12.448 0 0 1 5.083-9.51c1.27-.924 2.715-1.629 3.908-2.643 1.724-1.468 2.862-3.534 4.78-4.765 2-1.286 4.593-1.485 6.646-2.7 1.9-1.125 3.154-3 4.742-4.5s3.901-2.894 6.108-2.542Z",
    "data-name": "Path 24292"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 1481",
    transform: "translate(-22082.813 -7083.767)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 1482",
    transform: "translate(-22075.207 -7088.953)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 1483",
    transform: "translate(-22084.494 -7089.829)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 1484",
    transform: "translate(-22096.051 -7080.547)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 1485",
    transform: "translate(-22088.445 -7086.077)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 1486",
    transform: "translate(-22097.732 -7086.986)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27977",
    transform: "rotate(-140 -12341.151 483.368)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 1487",
    transform: "rotate(-30 13.59 .271)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 1488",
    transform: "rotate(-30 7.073 -16.679)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.392,
    cy: 0.392,
    r: 0.392,
    "data-name": "Ellipse 1489",
    transform: "rotate(-30 .731 .196)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSand);
export default __webpack_public_path__ + "static/media/Sand.0b8c7b1fbab9044e11b483bedfa766ae.svg";
export { ForwardRef as ReactComponent };